import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  useScreenClass,
  Row,
  Col,
  Hidden,
  Visible
} from 'components/Grid';

import {
  Section,
  Container,
  Image,
  Title,
  Text
} from './styles';

const TopWave = () => {
  const { t } = useTranslation();
  const screenClass = useScreenClass();

  return (
    <Section>
      <Container>
        <Row
          align="center"
          gutterWidth={75}
          direction={screenClass === 'xs' ? 'column-reverse' : 'row'}
        >
          <Col xs={12} sm={6}>
            <Image alt="Caring" src="/assets/images/wave/image.svg" />
          </Col>
          <Col xs={12} sm={6}>
            <Hidden xs>
              <Title>{t('WAVE.TOP_WAVE.TITLE')}</Title>
              <Text>{t('WAVE.TOP_WAVE.TEXT')}</Text>
            </Hidden>
            <Visible xs>
              <Title.xs>{t('WAVE.TOP_WAVE.TITLE')}</Title.xs>
              <Text.xs>{t('WAVE.TOP_WAVE.TEXT')}</Text.xs>
            </Visible>
          </Col>
        </Row>
      </Container>
    </Section>
  );
};

export default TopWave;
